module.exports = __webpack_public_path__ + "static/img/7-2.62e41c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/7-2.png
// module id = wdnl
// module chunks = 10